export function clearChatLocalStorage() {
    const keysToRemove = [
        "step",
        "userAgentChats",
        "chatMessage",
        "isCompletedChat",
        "agentName",
        "typeAgent",
        "cid",
        "oid",
        "userDetails",
        "storedChatMessages",
        "chatInactivity"
    ];

    const sessionKeysToRemove = [
        "curai_token",
        "curai_expiry",
    ];

    keysToRemove.forEach(key => localStorage.removeItem(key));
    sessionKeysToRemove.forEach(key => sessionStorage.removeItem(key));
}
